import styles from "./rating.module.scss";
import Star from "assets/images/Star";

interface RatingProps {
  rating: number;
  setRating: (rating: number) => void;
}

const Rating: React.FC<RatingProps> = ({ rating, setRating }) => {
  const MAX_RATING = 5;

  return (
    <div className={styles.container}>
      {[...Array(rating)].map((_element, index) => (
        <Star
          className={styles.filled}
          key={"filled" + index}
          onClick={() => setRating(index + 1)}
        />
      ))}
      {[...Array(MAX_RATING - rating)].map((_element, index) => (
        <Star
          className={styles.empty}
          key={"empty" + index}
          onClick={() => setRating(index + rating + 1)}
          data-cy={"empty-" + index}
        />
      ))}
    </div>
  );
};

export default Rating;
